import { Box } from "@sane-ts/shadcn-ui/lucide";

export const loading = (
  <div className="grid h-full w-full place-items-center overflow-hidden">
    <Box
      className={`h-[50%] w-[50%] animate-spin`}
      style={{ animationDuration: "3s" }}
    />
  </div>
);
